import { Answer, MultiSelectContent, Score } from "../types";

export function markAnswer(
  content: MultiSelectContent,
  answers: Answer
): Score {
  if (!answers) {
    return {
      score: 0
    };
  }

  const numberOfGivenCorrectAnswers = answers.filter(answerIndex =>
    content.options.find((option, i) => option.correct && i === answerIndex)
  ).length;

  return {
    score: Number(
      (numberOfGivenCorrectAnswers / content.numberOfCorrectAnswers).toFixed(2)
    )
  };
}
